import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';

import { ConfigService } from '../../shared/utils/config.service';
import { BaseService } from '../../shared/services/base.service';

// Models
import { AuditTrailModel } from '../../shared/models/audit-trail.model';
import { GridFilterModel } from '../../shared/models/grid-filter.model'


@Injectable({
  providedIn: 'root'
})
export class AuditTrailService extends BaseService {
  baseApiUrl: string = '';
  auditTrailDetailsApiUrl: string = '';
  getAuditTrailDetailsByFromDateByToDateApiUrl: string = '';
  ipaddress = "http://api.ipify.org/?format=json";
  constructor(private http: HttpClient, private configService: ConfigService) {
    super();
    this.baseApiUrl = this.configService.getApiURI();
    this.auditTrailDetailsApiUrl = this.baseApiUrl + '/AuditTrail/AddAuditTrailData';
    this.getAuditTrailDetailsByFromDateByToDateApiUrl = this.baseApiUrl + '/AuditTrail/GetAuditTrailDetailsByFromDateByToDate';
  }

  
  auditTrailDetails(body: AuditTrailModel) {
    try {
      return this.http.post(this.auditTrailDetailsApiUrl, body).toPromise();
    }
    catch (Ex) {
      throw Ex;
    }
  }

  getAuditTrailDetailsByFromDateByToDate(body: GridFilterModel) {
    try {
      return this.http.post(this.getAuditTrailDetailsByFromDateByToDateApiUrl, body);
    }
    catch (Ex) {
      throw Ex;
    }
  }

   getIPAddress() {
    return this.http.get(encodeURI(this.ipaddress));
  }  
}
